import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, HeartCrackIcon, FrownIcon, UsersIcon, MessageCircleIcon, MagnetIcon } from 'lucide-react';
const painPoints = [{
  icon: <SearchIcon className="w-6 h-6 text-electric-blue" data-id="element-120" />,
  text: 'Sentís que alguien te miente pero no podés probarlo y terminás dudando de vos mismo/a.'
}, {
  icon: <HeartCrackIcon className="w-6 h-6 text-electric-blue" data-id="element-121" />,
  text: 'Tu pareja, amigo o colega actúa raro y no sabés si estás siendo paranoico/a o si hay algo real.'
}, {
  icon: <FrownIcon className="w-6 h-6 text-electric-blue" data-id="element-122" />,
  text: 'En el trabajo te ignoran, te pisan o te ninguean y no sabés cómo reaccionar sin quedar mal.'
}, {
  icon: <UsersIcon className="w-6 h-6 text-electric-blue" data-id="element-123" />,
  text: 'La gente dice una cosa pero hace otra y siempre terminás cayendo en lo mismo.'
}, {
  icon: <MessageCircleIcon className="w-6 h-6 text-electric-blue" data-id="element-124" />,
  text: 'Te cuesta leer el ambiente en reuniones, citas o conflictos y después te arrepentís de no haber actuado antes.'
}, {
  icon: <MagnetIcon className="w-6 h-6 text-electric-blue" data-id="element-125" />,
  text: 'Sentís que ciertos manipuladores o personas tóxicas siempre te encuentran a vos.'
}];
export function PainSection() {
  return <section className="pt-6 pb-6 px-4 bg-deep-black relative" data-id="element-126">
      <div className="max-w-5xl mx-auto" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-4" data-id="element-128">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-129">
            ¿Te pasa esto?
          </h2>
          <p className="text-sm text-smoke/80" data-id="element-130">
            Si dijiste que sí a cualquiera de estos puntos, este pack es para
            vos.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5 mb-4" data-id="element-131">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#141414] border border-white/5 p-3 rounded-lg flex items-start gap-2.5 hover:border-electric-blue/30 transition-colors" data-id="element-132">
              <div className="bg-deep-black p-2 rounded-md border border-white/5 shrink-0" data-id="element-133">
                {point.icon}
              </div>
              <p className="text-smoke text-sm leading-snug" data-id="element-134">{point.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="border border-gold bg-gold/5 p-3.5 rounded-lg text-center shadow-[0_0_30px_rgba(201,168,76,0.1)]" data-id="element-135">
          <p className="text-base md:text-lg font-heading font-medium text-gold leading-snug" data-id="element-136">
            "El problema no sos vos. Es que nadie te enseñó a leer el idioma
            real del cuerpo humano — ese que no miente aunque la boca sí lo
            haga."
          </p>
        </motion.div>
      </div>
    </section>;
}